import React, { useEffect } from 'react';
import './App.css';
import "antd/dist/antd.css";
import { AuthenticateDocument } from './AuthenticateDocument';
import { useState } from 'react';
import MainLayout from './components/MainLayout';
import External from './components/ExternalUser';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setConflictPreviewVerionstate, setIsReadOnly, setIsTemplateDocument } from './app/EditorSlice';

function App({ isExternal = false, isTemplateDocument = false }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const conflictPreviewVerion = useSelector((state) => state.editor.conflictPreviewVerion);

  useEffect(() => {
    dispatch(setIsTemplateDocument(isTemplateDocument));

    const searchParams = new URLSearchParams(document.location.search)
    const previewVerion = searchParams.get("versionType");
    if (previewVerion) {
      dispatch(setConflictPreviewVerionstate(previewVerion));
      dispatch(setIsReadOnly(true));
    }
  }, []);


  if (isExternal) {
    return <External />;
  }
  else {
    if (isAuthenticating && !conflictPreviewVerion) { // isAuthenticating
      return <AuthenticateDocument setIsLoading={setIsAuthenticating} />
    }
    else {
      return <MainLayout />;
    }
  }

}

export default App;
